import type { ProviderMatcher } from '../widgetMacroTypes.ts';

import { withUnit } from '../utils/urlMatcherUtils.ts';

const PATTERN = /https?:\/\/(.+\.)?web\.microsoftstream\.com\/(?:embed\/)?video\/([a-zA-Z0-9-]+)/;
const PATTERN_EMBED = /https?:\/\/(.+\.)?web\.microsoftstream\.com\/embed\/video\/([a-zA-Z0-9-]+)/;

const DEFAULT_WIDTH = '640px';
const DEFAULT_HEIGHT = '360px';

export const matchMicrosoftStream: ProviderMatcher = (url, params) => {
	if (!PATTERN.test(url)) {
		return null;
	}
	const embedUrl = PATTERN_EMBED.test(url)
		? url
		: `${url.replace('/video/', '/embed/video/')}?autoplay=false&showinfo=true`;
	return {
		kind: 'iframe',
		provider: 'Microsoft Stream',
		embedUrl,
		width: withUnit(params.width) ?? DEFAULT_WIDTH,
		height: withUnit(params.height) ?? DEFAULT_HEIGHT,
	};
};
